// поля «Под заказ», «Списывать остатки при покупке», ограничение доставки
// подкатегории и статус BLOCKED ещё не попали в сгенерированные типы
// @mivis/petmart-api — домёрживаем
declare global {
  namespace Components {
    namespace Schemas {
      interface IDimension {
        on_demand?: boolean
        auto_deduct_stock?: boolean
      }
      enum EProductStatus {
        BLOCKED = 'BLOCKED'
      }
      interface ISubCategory {
        delivery_restriction?: EDeliveryRestriction | null
      }
      interface ICreateSubCategoryRequest {
        delivery_restriction?: EDeliveryRestriction | null
      }
      interface IParsedSubCategory {
        delivery_restriction?: EDeliveryRestriction | null
      }
    }
  }
}

// Почему служба доставки не принимает товары подкатегории
export enum EDeliveryRestriction {
  FOOD = 'FOOD',
  MEDICINE = 'MEDICINE',
  TOXIC = 'TOXIC'
}

export interface IProductResponse
  extends Components.Schemas.IProductDraftResponse {
  type: EProductType
  parent_id?: string | null
  article: string
  external_item_id?: string
  disabled_by?: EProductDisabledReason | null
  disabled_reasons?: EProductDisabledReason[]
}
export interface IProductQueryRequest
  extends Components.Schemas.IProductQueryRequest {
  search_by?: string
  sort_by?: string
  sort_order?: string
  group?: string
  // товары с указанной подкатегорией либо без категории (подбор вариаций)
  subCategoryOrEmpty_id?: string
  // только товары, которые проходят условия общего фида
  feed_only?: string
}
export interface IProductQueryFilters
  extends Omit<
    Components.Schemas.IProductQueryRequest,
    'skip' | 'limit' | 'status'
  > {
  search_by?: string
  feed_only?: string
}
export interface IProductQueryResponse
  extends Components.Schemas.IProductQueryResponse { }
export interface ICreateProduct extends Components.Schemas.ICreateProduct { }
export interface ICreateProductVariation
  extends Components.Schemas.ICreateVariation {
  // id существующего родителя — бэкенд привяжет вариацию сразу при создании
  parent_id?: string
  // Без статуса бэкенд создаёт вариацию черновиком
  status?: EProductStatus.DRAFT | EProductStatus.PUBLISHED
}
export interface IUpdateProduct
  extends Partial<Components.Schemas.IUpdateProduct> {
  photoOrder?: string[]
}
export interface IProductAiGeneratedImage {
  generatedImage?: string
}
export interface IQuickUpdateProductRequest {
  price?: number
  in_stock?: number
}
export enum EPriceChangeSource {
  SELLER = 'SELLER',
  ADMIN = 'ADMIN',
  EXCEL_IMPORT = 'EXCEL_IMPORT',
  INSALES = 'INSALES',
  MOYSKLAD = 'MOYSKLAD',
  ONE_C = 'ONE_C',
  API = 'API',
  DISCOUNT = 'DISCOUNT',
  SYSTEM = 'SYSTEM'
}
export interface IPriceHistoryItem {
  _id: string
  product_id: string
  product_name: string | null
  // null в old_* — товар создан с этой ценой
  old_price: number | null
  new_price: number | null
  // f_price — цена до скидки, заполнена, пока на товаре действует скидка
  old_f_price: number | null
  new_f_price: number | null
  source: EPriceChangeSource
  // для DISCOUNT — название скидки
  note: string | null
  // null у правок администратора площадки, если журнал смотрит продавец
  author: { _id: string; name: string; email: string | null } | null
  createdAt: string
}
export interface IPriceHistoryProduct {
  _id: string
  name: string
  type: EProductType
  price: number
  f_price: number | null
  createdAt: string
}
// Журнал всей карточки: основной товар первым, за ним вариации
export interface IPriceHistoryResponse {
  products: IPriceHistoryProduct[]
  items: IPriceHistoryItem[]
}
export interface IUpdateProductVariation
  extends Partial<Components.Schemas.IUpdateProduct> { }
export interface IUpdateProductStatus
  extends Pick<Components.Schemas.IUpdateProduct, 'status' | 'id'> { }
export enum EProductStatus {
  DRAFT = 'DRAFT',
  MODERATION = 'MODERATION',
  PUBLISHED = 'PUBLISHED',
  REJECTED = 'REJECTED',
  ARCHIVED = 'ARCHIVED',
  DISABLED = 'DISABLED',
  // Заблокирован администрацией: снять статус может только супер-админ
  BLOCKED = 'BLOCKED'
}
export enum EProductDisabledReason {
  MANUAL = 'MANUAL',
  VARIATION_MANUAL = 'VARIATION_MANUAL',
  HS_CATEGORY = 'HS_CATEGORY',
  MOYSKLAD_GROUP = 'MOYSKLAD_GROUP',
  MOYSKLAD_SYNC_ERROR = 'MOYSKLAD_SYNC_ERROR',
  SELLER_DISABLED = 'SELLER_DISABLED',
  EXCEL_STOCK_OUTDATED = 'EXCEL_STOCK_OUTDATED',
  STOCK_OUTDATED = 'STOCK_OUTDATED',
  DIMENSION_INCOMPLETE = 'DIMENSION_INCOMPLETE'
}
export interface IActionsProductRequest
  extends Partial<Components.Schemas.IActionsProductRequest> {
  // toBlock/toUnblock ещё нет в сгенерированной схеме — расширяем локально
  toBlock?: string
  toUnblock?: string
}
export interface IActionsProductResponse
  extends Components.Schemas.IActionsProductResponse { }
export enum EActionsProductRequest {
  DELETE = 'toDelete',
  PUBLISH = 'toPublish',
  COPY = 'toCopy',
  DRAFT = 'toDraft',
  REJECT = 'toReject',
  BLOCK = 'toBlock',
  UNBLOCK = 'toUnblock'
}

export interface ICategoryQueryRequest
  extends Components.Schemas.IAdminCategoryQueryRequest { }
export interface ICreateCategoryRequest
  extends Components.Schemas.ICreateCategoryRequest { }
export interface IUpdateCategoryRequest
  extends Components.Schemas.IUpdateCategoryRequest { }

export interface ICreateSubCategoryRequest
  extends Components.Schemas.ICreateSubCategoryRequest { }
export interface IUpdateSubCategoryRequest
  extends Components.Schemas.IUpdateSubCategoryRequest { }

export interface ICategory extends Components.Schemas.ICategory { }
// selected_sellers отдаётся бэком, но в схеме api-пакета его пока нет
export interface ICategoryWithSelectedSellers extends ICategory {
  selected_sellers?: string[]
}
export interface IUpdateSelectedSellersRequest {
  seller_ids: string[]
}
export interface ISubCategory extends Components.Schemas.ISubCategory { }
export interface IParsedCategory extends Components.Schemas.IParsedCategory { }
export interface IParsedSubCategory
  extends Components.Schemas.IParsedSubCategory { }
export enum ESubCategoryStatus {
  MODERATION = 'MODERATION',
  ACTIVE = 'ACTIVE'
}

export interface ITopProductSalesQueryRequest
  extends Components.Schemas.IAdminTopSalesQueryRequest { }
export interface ITopProductSalesResponse
  extends Components.Schemas.IAdminTopSalesResponse { }
export interface IProduct extends Components.Schemas.IProduct { }

export interface ICharacteristic extends Components.Schemas.ICharacteristic { }
export interface IAddVariation extends Components.Schemas.IAddVariation { }
export interface IDimension extends Components.Schemas.IDimension { }

export interface EnhancementImageResponse
  extends Components.Schemas.EnhancementImageResponse { }
export interface EnhancementCharacteristicsResponse
  extends Components.Schemas.EnhancementCharacteristicsResponse { }
export interface EnhancementDescriptionResponse
  extends Components.Schemas.EnhancementDescriptionResponse { }

export interface EnhanceImagePayload
  extends Components.Schemas.EnhanceImagePayload { }
export interface EnhanceCharacteristicsPayload
  extends Components.Schemas.EnhanceCharacteristicsPayload { }
export interface EnhanceDescriptionPayload
  extends Components.Schemas.EnhanceDescriptionPayload { }
export interface EnhanceBulkPayload
  extends Components.Schemas.EnhanceBulkPayload { }

export interface EnhancementListResponse
  extends Components.Schemas.EnhancementListResponse { }
export interface EnhancementResponse
  extends Components.Schemas.EnhancementResponse { }
export interface PaginateDto extends Components.Schemas.PaginateDto { }
export interface GetEnhancementDto
  extends Components.Schemas.GetEnhancementDto { }

export enum EUnit {
  KG = 'KG',
  GR = 'GR'
}

export enum EProductType {
  PRODUCT = 'PRODUCT',
  VARIATION = 'VARIATION'
}

export interface IPreviewData {
  photo: any
  categoryName: string
  subCategoryName: string
  name: string
  price: number
  desc: string
  dimension: IDimension
  characteristics: ICharacteristic[]
  variations: IFrontVariation[]
}

export interface IProductFormData {
  id?: string
  status?: EProductStatus
  external_item_id?: string
  name: string
  categories_id: string[]
  vendor_code: string
  price: string
  tax: number
  width: string
  length: string
  height: string
  weight: string
  unit: EUnit
  in_stock: string
  // «Под заказ»: остаток не редактируется, на карточке бейдж «Под заказ»
  on_demand?: boolean
  // Списывать остаток при покупке, не дожидаясь синхронизации остатков
  auto_deduct_stock?: boolean
  desc: string
  photo: any[]
  characteristicName?: string
  characteristicValues: string[]
  characteristics?: ICharacteristic[]
  optionalCharacteristics?: Array<{ name: string; value: string }>
  variations?: IFrontVariation[]
  requiredCharacteristics?: Array<{ name: string; value: string }>
}

export interface IFrontCategory extends ICategory {
  isNew: boolean
}

export interface IFrontSubCategory extends ISubCategory {
  isNew: boolean
}

export interface IFrontVariationProduct {
  id: string
  name: string
  price?: number
  status?: EProductStatus
  disabled_by?: EProductDisabledReason | null
  disabled_reasons?: EProductDisabledReason[]
}

export interface IFrontVariation {
  firstCharacteristicName?: string
  firstCharacteristicValue?: string
  secondCharacteristicName?: string
  secondCharacteristicValue?: string
  product?: IFrontVariationProduct
}

export interface IChangeVariationProduct {
  visible: boolean
  variation: IFrontVariation | null
  variationIndex: number | null
}

// Интерфейс для характеристик вариации (максимум 2)
export interface IVariationCharacteristics {
  firstCharacteristic?: { name: string; value: string }
  secondCharacteristic?: { name: string; value: string }
}

export interface ICreateUpdateVariationProduct extends IChangeVariationProduct {
  type: 'create' | 'update' | null
  // В упрощенной версии убираем все дополнительные поля
  // Характеристики приходят заблокированными из основного товара
}

export interface IProductVariationFormData {
  name: string
  vendor_code: string
  price: string
  tax: number
  width: string
  length: string
  height: string
  weight: string
  unit: EUnit
  in_stock: string
  on_demand?: boolean
  auto_deduct_stock?: boolean
  desc?: string
  photo?: any[]
  requiredCharacteristics?: Array<{ name: string; value: string }>
  optionalCharacteristics?: Array<{ name: string; value: string }>
}

export enum EEnhancementImageType {
  BACKGROUND = 'background',
  FULL = 'full',
  INFOGRAPHIC = 'infographic'
}

export interface AiEnhancementOptions {
  productName?: string
  improveDescription?: boolean
  characteristics?: boolean
  productImage?: boolean
  imageEnhancementType?: EEnhancementImageType
  improveDescriptionPrompt?: string
  fullEnhancementImagePrompt?: string
  initialImages?: EnhancementImageResponse[]
  selectedInitialImage?: EnhancementImageResponse
}

export interface AiEnhancementResponse {
  jobId: string
}

export type TEnhanceProductImageRequestType = 'removeBackground' | 'full' | 'infographic'
export type TEnhanceProductImageListType = 'background' | 'full' | 'infographic'

export interface IEnhanceProductRequest {
  productId: string
  description?: {
    additionalPrompt: string
    select: boolean
  }
  image?: {
    additionalPrompt: string
    select: boolean
    type: TEnhanceProductImageRequestType
    photoName: string
  }
}

export interface IEnhanceProductResponse {
  success: boolean
  jobId?: string
  descriptionJobId?: string
  imageJobId?: string
  message?: string
}

export interface ILatestEnhancementDescription {
  _id?: string
  enhancementId?: string
  new_desc?: string
}

export interface IEnhancementImageVariant {
  _id?: string
  enhancementId?: string
  image: string
}

export interface IEnhancementImageUrlResult {
  imageUrl: string
}

export type TEnhanceProductImageResult =
  | string
  | IEnhancementImageVariant
  | IEnhancementImageUrlResult

export interface IParentAndVariationsResponse {
  parent: IProductResponse
  variations: IProductResponse[]
}

// Новые типы для характеристик подкатегорий
export interface ISubCategoryCharacteristic {
  name: string
  isAnyValue: boolean
  required: boolean
  hints: string[]
}

export interface IGetSubCategoryCharacteristicsResponse {
  _id: string
  subcategory_id: string
  characteristics: ISubCategoryCharacteristic[]
  createdAt: string
  updatedAt: string
  __v: number
}

export interface IUpdateSubCategoryCharacteristicsRequest {
  characteristics: ISubCategoryCharacteristic[]
}
